import { pageHref } from '@/lib/blocks/page-link-search';

export type SearchToolResultChip = {
  id: string;
  title: string;
  type: 'page' | 'database';
  href: string;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value != null && !Array.isArray(value);
}

export function parseSearchToolResultChips(result: unknown): SearchToolResultChip[] {
  let parsed: Record<string, unknown> | null = null;
  if (isRecord(result)) {
    parsed = result;
  } else if (typeof result === 'string' && result.trim()) {
    try {
      const json: unknown = JSON.parse(result);
      parsed = isRecord(json) ? json : null;
    } catch {
      return [];
    }
  }
  if (!parsed || !Array.isArray(parsed.results)) {
    return [];
  }

  const seen = new Set<string>();
  const chips: SearchToolResultChip[] = [];
  for (const row of parsed.results) {
    if (!isRecord(row)) {
      continue;
    }
    const containerId =
      typeof row.containerId === 'string'
        ? row.containerId
        : typeof row.id === 'string'
          ? row.id
          : null;
    if (!containerId || seen.has(containerId)) {
      continue;
    }
    seen.add(containerId);
    const containerType =
      row.containerType === 'database' || row.type === 'database' ? 'database' : 'page';
    const title =
      typeof row.containerTitle === 'string' && row.containerTitle.trim()
        ? row.containerTitle.trim()
        : typeof row.title === 'string' && row.title.trim()
          ? row.title.trim()
          : 'Untitled';
    chips.push({
      id: containerId,
      title,
      type: containerType,
      href: pageHref({ id: containerId, type: containerType }),
    });
    if (chips.length >= 6) {
      break;
    }
  }
  return chips;
}
